// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file gateway/v1/auth.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gateway/v1/auth.proto.
 */
export const file_gateway_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("ChVnYXRld2F5L3YxL2F1dGgucHJvdG8SCmdhdGV3YXkudjEiLwoMTG9naW5SZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJIjwKDUxvZ2luUmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEhUKDXJlZnJlc2hfdG9rZW4YAiABKAkiJgoNTG9nb3V0UmVxdWVzdBIVCg1yZWZyZXNoX3Rva2VuGAEgASgJIhAKDkxvZ291dFJlc3BvbnNlIiIKEUNoZWNrVG9rZW5SZXF1ZXN0Eg0KBXRva2VuGAEgASgJIjgKEkNoZWNrVG9rZW5SZXNwb25zZRITCgt0b2tlbl92YWxpZBgBIAEoCBINCgVlbWFpbBgCIAEoCSIsChNSZWZyZXNoVG9rZW5SZXF1ZXN0EhUKDXJlZnJlc2hfdG9rZW4YASABKAkiQwoUUmVmcmVzaFRva2VuUmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEhUKDXJlZnJlc2hfdG9rZW4YAiABKAkytgIKFUF1dGhlbnRpY2F0aW9uU2VydmljZRI8CgVMb2dpbhIYLmdhdGV3YXkudjEuTG9naW5SZXF1ZXN0GhkuZ2F0ZXdheS52MS5Mb2dpblJlc3BvbnNlEj8KBkxvZ291dBIZLmdhdGV3YXkudjEuTG9nb3V0UmVxdWVzdBoaLmdhdGV3YXkudjEuTG9nb3V0UmVzcG9uc2USSwoKQ2hlY2tUb2tlbhIdLmdhdGV3YXkudjEuQ2hlY2tUb2tlblJlcXVlc3QaHi5nYXRld2F5LnYxLkNoZWNrVG9rZW5SZXNwb25zZRJRCgxSZWZyZXNoVG9rZW4SHy5nYXRld2F5LnYxLlJlZnJlc2hUb2tlblJlcXVlc3QaIC5nYXRld2F5LnYxLlJlZnJlc2hUb2tlblJlc3BvbnNlQmQKDmNvbS5nYXRld2F5LnYxQglBdXRoUHJvdG9QAaICA0dYWKoCCkdhdGV3YXkuVjHKAgpHYXRld2F5XFYx4gIWR2F0ZXdheVxWMVxHUEJNZXRhZGF0YeoCC0dhdGV3YXk6OlYxYgZwcm90bzM");

/**
 * LoginRequest is the request message for authenticating a user.
 *
 * @generated from message gateway.v1.LoginRequest
 */
export type LoginRequest = Message<"gateway.v1.LoginRequest"> & {
  /**
   * email is the user's email address used as login identifier.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * password is the user's password.
   *
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message gateway.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 0);

/**
 * LoginResponse is the response message for the Login RPC.
 *
 * @generated from message gateway.v1.LoginResponse
 */
export type LoginResponse = Message<"gateway.v1.LoginResponse"> & {
  /**
   * access_token is the JWT access token for authenticating subsequent requests.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * refresh_token is the token used to obtain a new access token when the current one expires.
   *
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 1);

/**
 * LogoutRequest is the request message for ending a user's session.
 *
 * @generated from message gateway.v1.LogoutRequest
 */
export type LogoutRequest = Message<"gateway.v1.LogoutRequest"> & {
  /**
   * refresh_token is the refresh token to invalidate.
   *
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 2);

/**
 * LogoutResponse is the response message for the Logout RPC.
 *
 * @generated from message gateway.v1.LogoutResponse
 */
export type LogoutResponse = Message<"gateway.v1.LogoutResponse"> & {
};

/**
 * Describes the message gateway.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 3);

/**
 * CheckTokenRequest is the request message for validating a token.
 *
 * @generated from message gateway.v1.CheckTokenRequest
 */
export type CheckTokenRequest = Message<"gateway.v1.CheckTokenRequest"> & {
  /**
   * token is the JWT token to validate.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message gateway.v1.CheckTokenRequest.
 * Use `create(CheckTokenRequestSchema)` to create a new message.
 */
export const CheckTokenRequestSchema: GenMessage<CheckTokenRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 4);

/**
 * CheckTokenResponse is the response message for the CheckToken RPC.
 *
 * @generated from message gateway.v1.CheckTokenResponse
 */
export type CheckTokenResponse = Message<"gateway.v1.CheckTokenResponse"> & {
  /**
   * token_valid indicates whether the provided token is valid.
   *
   * @generated from field: bool token_valid = 1;
   */
  tokenValid: boolean;

  /**
   * email is the email address associated with the token's user.
   *
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message gateway.v1.CheckTokenResponse.
 * Use `create(CheckTokenResponseSchema)` to create a new message.
 */
export const CheckTokenResponseSchema: GenMessage<CheckTokenResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 5);

/**
 * RefreshTokenRequest is the request message for refreshing an access token.
 *
 * @generated from message gateway.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"gateway.v1.RefreshTokenRequest"> & {
  /**
   * refresh_token is the current refresh token to exchange.
   *
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 6);

/**
 * RefreshTokenResponse is the response message for the RefreshToken RPC.
 *
 * @generated from message gateway.v1.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"gateway.v1.RefreshTokenResponse"> & {
  /**
   * access_token is the new JWT access token.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * refresh_token is the new refresh token.
   *
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message gateway.v1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_auth, 7);

/**
 * AuthenticationService defines the gRPC service for managing authentication.
 *
 * -------------------------------------------------------------------------
 * Authentication operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.AuthenticationService
 */
export const AuthenticationService: GenService<{
  /**
   * Login authenticates a user with their credentials and returns access and refresh tokens.
   *
   * @generated from rpc gateway.v1.AuthenticationService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * Logout invalidates the provided refresh token, ending the user's session.
   *
   * @generated from rpc gateway.v1.AuthenticationService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * CheckToken validates a token and returns the associated user information if valid.
   *
   * @generated from rpc gateway.v1.AuthenticationService.CheckToken
   */
  checkToken: {
    methodKind: "unary";
    input: typeof CheckTokenRequestSchema;
    output: typeof CheckTokenResponseSchema;
  },
  /**
   * RefreshToken exchanges a valid refresh token for a new pair of access and refresh tokens.
   *
   * @generated from rpc gateway.v1.AuthenticationService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gateway_v1_auth, 0);

